import { useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart, faPlusCircle } from "@fortawesome/free-solid-svg-icons"
import { useGetExercisesQuery, useAddNewFavoriteMutation, useDeleteFavoriteMutation } from "./exercisesApiSlice"
import { memo } from 'react'
import { toast } from 'react-toastify'


const ExerciseForUsers = ({ exerciseId, favorites, userId, isMobile }) => {

	// get exercise data
	const { exercise } = useGetExercisesQuery("exercisesList", {
		selectFromResult: ({ data }) => ({
			exercise: data?.entities[exerciseId]
		}),
	})

	// see if exercise is a favorite
	let IsVisible
	let icon
	let iconClass
	if (favorites) {
		IsVisible = favorites.filter(item => exerciseId === item.exercise_id).length > 0
		icon = IsVisible ? faHeart : faPlusCircle
		iconClass = IsVisible ? 'fa-icon text-success' : 'fa-icon'
	} else {
		IsVisible = false
		icon = faPlusCircle
		iconClass = 'fa-icon'
	}

	// add or delete favorite
	const [addNewFavorite, {
		isError,
		error
	}] = useAddNewFavoriteMutation()

	const [deleteFavorite, {
		isError: delIsError,
		error: delError
	}] = useDeleteFavoriteMutation()

	useEffect(() => {
		if (isError) {
			toast.error(error?.data?.message);
		}
		if (delIsError) {
			toast.error(delError?.data?.message);
		}
	}, [isError, error, delIsError, delError])



	const onFavoriteClicked = async () => {
		if (IsVisible) {
			// delete favorite
			await deleteFavorite({ exerciseID: exerciseId, userID: userId })
		} else {
			// add favorite
			await addNewFavorite({ exerciseID: exerciseId, userID: userId })
		}
	}



	// show the row
	if (exercise) {

		let video = ''
		if (exercise.video) {
			video = <a target="_blank" rel="noreferrer" href={exercise.video}>Watch</a>
		}

		return (
			<tr>
				<td style={{ width: isMobile ? '60%' : '40%' }}>
					<FontAwesomeIcon icon={icon} className={iconClass} style={{ marginRight: '10px' }} onClick={onFavoriteClicked} />
                    {isMobile===true ? exercise.exercise_name.substr(0,20)+'...' : exercise.exercise_name.substr(0,40)+'...'}
				</td>
				{isMobile === false && <td style={{ width: '20%' }}>{exercise.exercisetype}</td>}
				{isMobile === false && <td style={{ width: '20%' }}>{exercise.bodypart}</td>}
				<td style={{ width: '20%' }}>{video}</td>
			</tr>
		)

	} else return null
}

const memoizedExercise = memo(ExerciseForUsers)

export default memoizedExercise